import React, { memo } from 'react';
import s from './DataBarsWrapper.scss';
import InfoMsg from '../InfoMsg/InfoMsg';

const DataBarsWrapper = ({
  children,
  totalSeats,
  majority,
  exitPoll,
  noMinHeight,
  countOfLeadPlusWins = false,
  infoMsg = '',
}) => (
  <div className={`${s.dataBarWrapper} ${noMinHeight ? s.noMinHeight : ''}`}>
    <div className={s.dbwInner}>
      <div className={s.dbTopHead}>
        <div className={s.totalSeats}>
          Seats: {totalSeats}
          {infoMsg && <InfoMsg msg={infoMsg} />}
        </div>
        {exitPoll && <span>Expected</span>}
        {countOfLeadPlusWins &&
          (countOfLeadPlusWins.winCount === totalSeats ? (
            <span>Results</span>
          ) : (
            <span>L + W</span>
          ))}
      </div>
      {majority && <div className={s.majorityMark}>Majority: {majority}</div>}
      {children}
    </div>
  </div>
);

export default memo(DataBarsWrapper);
